import {
	CollectionModelBrightnessCorrection,
	CollectionModelBrightnessCorrectionMutator,
	type ModelStateBrightnessCorrection,
} from './brightnessCorrection';

export interface ModelStateGammaBrightnessCorrection extends ModelStateBrightnessCorrection {
	tag: 'gamma';
	exponent: number;
}

export class CollectionModelGammaBrightnessCorrectionMutator extends CollectionModelBrightnessCorrectionMutator<CollectionModelGammaBrightnessCorrection> {
	constructor(brightnessCorrection: CollectionModelGammaBrightnessCorrection) {
		super(brightnessCorrection);
	}

	init(exponent: number) {
		this.brightnessCorrection.brightnessCorrectionState.Mutator.create('gamma');
		this.setExponent(exponent);
	}

	setExponent(exponent: number) {
		const state = this.getValue();
		state.exponent = exponent;
		this.setValue(state);
	}
}

export class CollectionModelGammaBrightnessCorrection extends CollectionModelBrightnessCorrection<ModelStateGammaBrightnessCorrection> {
	static state(id: string): ModelStateGammaBrightnessCorrection {
		return {
			id,
			tag: 'gamma',
			exponent: 1,
		};
	}

	static readonly TAG = 'gamma' as const;
	readonly tag = CollectionModelGammaBrightnessCorrection.TAG;
	override Mutator = new CollectionModelGammaBrightnessCorrectionMutator(this);

	static isGamma(t: CollectionModelBrightnessCorrection): t is CollectionModelGammaBrightnessCorrection {
		return t.tag === CollectionModelGammaBrightnessCorrection.TAG;
	}

	get exponent(): number {
		const state = this.state;
		if (!state) {
			return 1;
		}
		return state.exponent;
	}
}
